import { FC, ReactNode } from 'react';

export interface EmptyProps {
  title?: string;
  description?: string;
  actions?: ReactNode;
}

export const Empty: FC<EmptyProps> = ({ title, description, actions }) => (
  <div className="empty flex flex-col gap-4 text-center py-8 md:py-12 px-8">
    {title && <h3 className="empty__title">{title}</h3>}
    {description && <p className="empty__description">{description}</p>}
    {actions && <div className="empty__actions inline-flex justify-center flex-wrap gap-2">{actions}</div>}
  </div>
);
